export default __webpack_public_path__ + "c018e2b6df3ac2464c29b4c42ea4492e.png";